module.exports = __webpack_public_path__ + "static/img/default-course.b79ea08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default-course.png
// module id = CggJ
// module chunks = 38